import { useToggle } from '@/utils/sharedHooks'
import { CSSProperties } from 'react'

import { Card, CardColors } from '@/ui'
import { UserTaxEstimate } from '../userTaxEstimates.slice'
import { LeftColumn } from './row-components/LeftColumn'
import { RightColumn } from './row-components/RightColumn'
import { TaxEstimateCta } from './row-components/TaxEstimateCta'

export const UserTaxEstimateSummary = ({
  estimate,
  overrideBgColor,
  style,
}: {
  estimate: UserTaxEstimate | null
  overrideBgColor?: CardColors
  style?: CSSProperties
}) => {
  const [toggleOpen, setToggleOpen] = useToggle(false)

  return (
    <div style={style}>
      <Card color={overrideBgColor as CardColors}>
        <div className="w-full space-y-6">
          <div className="flex flex-col sm:flex-row gap-4">
            <LeftColumn estimateId={estimate?.id} />
            <RightColumn
              estimateId={estimate?.id}
              toggleOpen={toggleOpen}
              setToggleOpen={setToggleOpen}
            />
          </div>

          <TaxEstimateCta estimateId={estimate?.id} />
        </div>
      </Card>
    </div>
  )
}
